{
	"textures": [
		{
			"image": "tree",
			"format": "RGBA8888",
			"size": {
				"w": 774,
				"h": 2017
			},
			"scale": 1,
			"frames": [
				{
					"filename": "tree/tree08",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 519,
						"h": 603
					},
					"spriteSourceSize": {
						"x": 77,
						"y": 39,
						"w": 390,
						"h": 550
					},
					"frame": {
						"x": 0,
						"y": 0,
						"w": 390,
						"h": 550
					}
				},
				{
					"filename": "tree/tree02",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 519,
						"h": 603
					},
					"spriteSourceSize": {
						"x": 104,
						"y": 100,
						"w": 360,
						"h": 489
					},
					"frame": {
						"x": 0,
						"y": 550,
						"w": 360,
						"h": 489
					}
				},
				{
					"filename": "tree/tree03",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 519,
						"h": 603
					},
					"spriteSourceSize": {
						"x": 104,
						"y": 100,
						"w": 360,
						"h": 489
					},
					"frame": {
						"x": 0,
						"y": 1039,
						"w": 360,
						"h": 489
					}
				},
				{
					"filename": "tree/tree04",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 519,
						"h": 603
					},
					"spriteSourceSize": {
						"x": 77,
						"y": 100,
						"w": 387,
						"h": 489
					},
					"frame": {
						"x": 0,
						"y": 1528,
						"w": 387,
						"h": 489
					}
				},
				{
					"filename": "tree/tree05",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 519,
						"h": 603
					},
					"spriteSourceSize": {
						"x": 77,
						"y": 100,
						"w": 387,
						"h": 489
					},
					"frame": {
						"x": 360,
						"y": 550,
						"w": 387,
						"h": 489
					}
				},
				{
					"filename": "tree/tree06",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 519,
						"h": 603
					},
					"spriteSourceSize": {
						"x": 77,
						"y": 100,
						"w": 387,
						"h": 489
					},
					"frame": {
						"x": 360,
						"y": 1039,
						"w": 387,
						"h": 489
					}
				},
				{
					"filename": "tree/tree07",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 519,
						"h": 603
					},
					"spriteSourceSize": {
						"x": 77,
						"y": 100,
						"w": 387,
						"h": 489
					},
					"frame": {
						"x": 387,
						"y": 1528,
						"w": 387,
						"h": 489
					}
				},
				{
					"filename": "tree/tree01",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 519,
						"h": 603
					},
					"spriteSourceSize": {
						"x": 143,
						"y": 193,
						"w": 231,
						"h": 397
					},
					"frame": {
						"x": 390,
						"y": 0,
						"w": 231,
						"h": 397
					}
				},
				{
					"filename": "tree/tree00",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 519,
						"h": 603
					},
					"spriteSourceSize": {
						"x": 201,
						"y": 342,
						"w": 83,
						"h": 223
					},
					"frame": {
						"x": 621,
						"y": 0,
						"w": 83,
						"h": 223
					}
				}
			]
		}
	],
	"meta": {
		"app": "http://free-tex-packer.com",
		"version": "0.6.7"
	}
}